import { config } from '@/config'

export const resetStorageKey = () => {
  localStorage?.removeItem(config.authKey)
}
